import React, { useState, useEffect, useRef } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import './PaymentReturn.css';

const REDIRECT_SECONDS = 5;

const SetupReturn = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [countdown, setCountdown] = useState(REDIRECT_SECONDS);
  const [status, setStatus] = useState('loading'); // 'loading' | 'success' | 'error'
  const intervalRef = useRef(null);

  const redirectStatus = searchParams.get('redirect_status');

  useEffect(() => {
    if (redirectStatus !== 'succeeded') {
      setStatus('error');
      return;
    }
    // Small delay so the loading state is visible briefly
    const t = setTimeout(() => setStatus('success'), 600);
    return () => clearTimeout(t);
  }, [redirectStatus]);

  // Start countdown once status is resolved
  useEffect(() => {
    if (status === 'loading') return;

    intervalRef.current = setInterval(() => {
      setCountdown((c) => {
        if (c <= 1) {
          clearInterval(intervalRef.current);
          navigate('/profile-management');
          return 0;
        }
        return c - 1;
      });
    }, 1000);

    return () => clearInterval(intervalRef.current);
  }, [status, navigate]);

  const handleGoNow = () => {
    clearInterval(intervalRef.current);
    navigate('/profile-management');
  };

  if (status === 'loading') {
    return (
      <div className="pr-page">
        <div className="pr-card">
          <div className="pr-spinner-wrap">
            <div className="pr-spinner" />
          </div>
          <p className="pr-loading-text">Confirming your setup…</p>
        </div>
      </div>
    );
  }

  if (status === 'error') {
    return (
      <div className="pr-page">
        <div className="pr-card pr-card--error">
          <div className="pr-icon pr-icon--error">✕</div>
          <h1 className="pr-title">Setup Unsuccessful</h1>
          <p className="pr-subtitle">
            Something went wrong and your auto top-up could not be activated. You have not been charged.
          </p>
          <button className="pr-btn" onClick={handleGoNow}>
            Back to Dashboard
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="pr-page">
      <div className="pr-card">
        {/* Animated tick */}
        <div className="pr-icon-wrap">
          <svg className="pr-checkmark" viewBox="0 0 52 52">
            <circle className="pr-checkmark__circle" cx="26" cy="26" r="25" fill="none" />
            <path className="pr-checkmark__check" fill="none" d="M14 27l8 8 16-16" />
          </svg>
        </div>

        <h1 className="pr-title">Auto Top-up Activated</h1>
        <p className="pr-subtitle">Your payment method has been saved successfully.</p>

        <div className="pr-details">
          <div className="pr-detail-row">
            <span className="pr-detail-label">Status</span>
            <span className="pr-detail-value pr-detail-value--active">
              <span className="pr-status-dot" /> Active
            </span>
          </div>
          <div className="pr-detail-row">
            <span className="pr-detail-label">Automatic charges</span>
            <span className="pr-detail-value">Enabled</span>
          </div>
        </div>

        <p className="pr-info-note">
          Your card will be charged automatically whenever your balance drops below your chosen threshold.
        </p>

        <button className="pr-btn" onClick={handleGoNow}>
          Go to Dashboard
        </button>

        <p className="pr-redirect-note">
          Redirecting in <span className="pr-countdown">{countdown}</span>s…
        </p>
      </div>
    </div>
  );
};

export default SetupReturn;
